import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";

export default function FolderDialog({
  open,
  onOpenChange,
  form,
  setForm,
  onSave,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#171717] border-[#262626] text-white max-w-sm"
        data-testid="folder-dialog"
      >
        <DialogHeader>
          <DialogTitle
            className="font-bold tracking-tight uppercase"
            style={{ fontFamily: "Barlow Condensed, sans-serif" }}
          >
            NUOVA CARTELLA
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">Nome</Label>
            <Input
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="folder-name-input"
            />
          </div>
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">Descrizione</Label>
            <Input
              value={form.description}
              onChange={(e) =>
                setForm({ ...form, description: e.target.value })
              }
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="folder-description-input"
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="border-[#262626] text-zinc-300 hover:bg-[#1A1A1A]"
            data-testid="folder-cancel-button"
          >
            Annulla
          </Button>
          <Button
            onClick={onSave}
            className="bg-[#007AFF] hover:bg-[#3395FF] text-white"
            data-testid="folder-save-button"
          >
            Crea
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
